import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import React from "react";
import { ManageStyle } from "../Config/Style";
import { Data } from "../Config/Static";
import { useCallback } from "react";
import CustomButton from "../Components/CustomButton";

const ManageDashboard = ({
  openmanage,
  handleClose,
  list,
  handleCheckboxChange,
  handleManage,
}) => {
  return (
    <Modal open={openmanage} onClose={handleClose} sx={ManageStyle.modal}>
      <Box sx={ManageStyle.box}>
        {/* Header */}
        <Box sx={ManageStyle.heading}>
          <Typography sx={{ fontSize: "22px" }}>Manage Dashboard</Typography>
          <IconButton onClick={handleClose}>
            <img
              src={require("../assets/delete.png")}
              width={"15px"}
              height={"15px"}
              alt="Close"
            />
          </IconButton>
        </Box>

        {/* Dashboard Actions */}
        <Box>
          <Typography sx={ManageStyle.typo}>Dashboard Actions</Typography>
          <Box sx={ManageStyle.btns}>
            {Data.buttons.map((item) => (
              <Button
                sx={{ textTransform: "none" }}
                onClick={() => handleManage(item)}
              >
                {item}
              </Button>
            ))}
          </Box>

          {/* Checkbox List */}
          <FormControl sx={{ m: 2 }} component="fieldset" variant="standard">
            <FormLabel sx={ManageStyle.formlabel}>
              Select Widgets to Display
            </FormLabel>
            <FormGroup>
              {list.map((item, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={item.display}
                      onChange={() => handleCheckboxChange(item.id)}
                      name={item.name}
                      disabled={item.id === "1"}
                    />
                  }
                  label={item.label}
                />
              ))}
            </FormGroup>
          </FormControl>
        </Box>

        {/* Footer */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
          <CustomButton
            text={"Close"}
            color={"#3D52A0"}
            bgcolor={"white"}
            border={"#3D52A0"}
            onClick={handleClose}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ManageDashboard;
